import { useEffect, useState } from 'react';

/**
 * Bridge between the CSS design tokens (src/styles/theme.css) and JS-land
 * consumers (ECharts, AG Grid, SweetAlert, fabric...).
 *
 * Rule: JS code must never hardcode UI colors — read them from the tokens so
 * both themes stay correct. See 0_web_labelflow/DESIGN_GUIDE.md.
 */

/** Read a CSS design token off <html> (e.g. getToken('--foreground')). */
export const getToken = (name, fallback = '') => {
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
};

/** 'dark' | 'light' — matches the class the theme toggle puts on <html>. */
export const getCurrentTheme = () =>
  document.documentElement.classList.contains('light') ? 'light' : 'dark';

/**
 * React hook that re-renders the component whenever the theme class on <html>
 * changes, so token-derived options (charts, grids) rebuild with fresh colors.
 */
export const useTheme = () => {
  const [theme, setTheme] = useState(getCurrentTheme);

  useEffect(() => {
    const observer = new MutationObserver(() => setTheme(getCurrentTheme()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  return theme;
};
